<!-- home.component.html -->

<section class="hero-section">
  <app-hero></app-hero>
</section>

<!-- Testimonials/Bewertungen -->
<section class="testimonials-section" aria-labelledby="testimonials-heading">
  <div class="container">
    <h2 id="testimonials-heading" class="section-title">Was unsere Leser sagen</h2>
    <div class="testimonials-grid">

      <figure class="testimonial-card" role="group" aria-labelledby="testimonial-lisa">
        <div class="testimonial-rating" aria-hidden="true">
          <span class="star filled">★</span>
          <span class="star filled">★</span>
          <span class="star filled">★</span>
          <span class="star filled">★</span>
          <span class="star filled">★</span>
        </div>
        <blockquote>
          <p id="testimonial-lisa">"Dank der detaillierten Tipps zum Einfrieren von Kräutern habe ich jetzt das ganze Jahr über frische Aromen in meiner Küche. Die Rezepte sind einfach nachzukochen und schmecken fantastisch!"</p>
        </blockquote>
        <figcaption class="testimonial-author">
          <p>Lisa M., Hobbygärtnerin</p>
        </figcaption>
      </figure>

      <figure class="testimonial-card" role="group" aria-labelledby="testimonial-laura">
        <div class="testimonial-rating" aria-hidden="true">
          <span class="star filled">★</span>
          <span class="star filled">★</span>
          <span class="star filled">★</span>
          <span class="star filled">★</span>
          <span class="star half">★</span>
        </div>
        <blockquote>
          <p id="testimonial-laura">"Die Tipps sind super verständlich und machen richtig Lust, Kräuter im Alltag auszuprobieren. Besonders spannend fand ich, wie vielseitig Minze ist – seit ich sie bei Kopfschmerzen anwende, greife ich viel seltener zu Tabletten."</p>
        </blockquote>
        <figcaption class="testimonial-author">
          <p>Laura M., Gesundheitsbewusste Leserin</p>
        </figcaption>
      </figure>

      <figure class="testimonial-card" role="group" aria-labelledby="testimonial-maria">
        <div class="testimonial-rating" aria-hidden="true">
          <span class="star filled">★</span>
          <span class="star filled">★</span>
          <span class="star filled">★</span>
          <span class="star filled">★</span>
          <span class="star filled">★</span>
        </div>
        <blockquote>
          <p id="testimonial-maria">"Ich hatte immer Probleme damit, meine Kräuter am Leben zu erhalten. Die Pflegetipps auf dieser Seite haben das komplett geändert - mein kleiner Balkon-Kräutergarten gedeiht prächtig!"</p>
        </blockquote>
        <figcaption class="testimonial-author">
          <p>Maria S., Anfängerin im Kräuteranbau</p>
        </figcaption>
      </figure>

    </div>
  </div>
</section>

<!-- Über uns -->
<section class="about-section" aria-labelledby="about-heading">
  <div class="container">
    <div class="about-content">
      <div class="about-image">
        <img
          [src]="imageService.getOptimizedImageUrl('kraeuterkorb-natur.webp', { width: 768, quality: 80, format: 'auto' })"
          [attr.srcset]="imageService.buildSrcset('kraeuterkorb-natur.webp', [480, 768, 1024], { quality: 80, format: 'auto' })"
          sizes="(max-width: 992px) 100vw, 50vw"
          width="768"
          height="512"
          alt="Kräuterexperte bei der Ernte frischer Heilkräuter"
          decoding="async"
          loading="lazy"
          style="object-fit: cover; width:100%; height:auto;">
      </div>

      <div class="about-text">
        <h2 id="about-heading">Über Kräutersaat</h2>
        <p>
          Kräutersaat ist eine Informationssammlung rund um gängige Küchenkräuter und Heilkräuter, ihre Anzucht und sinnvolle Anwendung. Unser Schwerpunkt liegt auf
          fundierten Tipps — wie man Kräuter sicher pflanzt, erntet, konserviert und als Hausmittel anwendet.
        </p>
        <p class="disclaimer">
          Hinweis: Unsere Inhalte dienen der Information und Praxisanleitung. Sie ersetzen keinen ärztlichen Rat. Bei Unsicherheit oder bei bestehenden
          gesundheitlichen Problemen konsultiere bitte eine Ärztin / einen Arzt.
        </p>
        <a [routerLink]="aboutPath" class="btn-secondary">Mehr über uns erfahren</a>
      </div>
    </div>
  </div>
</section>

<!-- Heilkräuter & Anwendungen -->
<section class="remedies-section" aria-labelledby="remedies-heading">
  <div class="container">
    <div class="remedies-content">
      <div class="remedies-text">
        <h2 id="remedies-heading">Heilkräuter & Anwendung</h2>
        <p>
          Wir erklären, wie du Heilkräuter gezielt als einfache Hausmittel nutzen kannst — verständlich, sicher und alltagsnah.
          Von bewährten Teerezepten über ätherische Öle bis zu Tinkturen und Umschlägen: praktische Schritt-für-Schritt-Anleitungen inklusive Hinweisen zu
          Dosierung, Verträglichkeit und Wechselwirkungen.
        </p>
        <ul>
          <li>Praktische Anleitungen: Teeaufguss, Tinktur, Öl, Salbe</li>
          <li>Wann helfen Kräuter — und wann sollte man zum Arzt?</li>
          <li>Sicherheitsinfos: Wechselwirkungen, Allergien, richtige Dosierung</li>
          <li>Rezeptideen für den Alltag (kurz, einfach, wirkungsorientiert)</li>
        </ul>

        <!-- Link bewusst auskommentiert falls separate Seite fehlt -->
        <!-- <a routerLink="/heilanwendung" class="btn-primary">Anwendungstipps entdecken</a> -->
      </div>

      <div class="remedies-image">
        <img
          [src]="imageService.getOptimizedImageUrl('69736e52790b8658078e51dd.webp', { width: 768, quality: 80, format: 'auto' })"
          [attr.srcset]="imageService.buildSrcset('69736e52790b8658078e51dd.webp', [480, 768, 1024], { quality: 80, format: 'auto' })"
          sizes="(max-width: 992px) 100vw, 50vw"
          width="768"
          height="512"
          alt="Aufbereitung von Heilkräutern zu Tees und Tinkturen"
          decoding="async"
          loading="lazy"
          style="object-fit: cover; width:100%; height:auto;">
      </div>
    </div>
  </div>
</section>

<!-- Kräuter anbauen Tipps -->
<section class="growing-section" aria-labelledby="growing-heading">
  <div class="container">
    <div class="growing-content">

      <div class="growing-image">
        <img
          [src]="imageService.getOptimizedImageUrl('schnittlauch-thymian.webp', { width: 768, quality: 80, format: 'auto' })"
          [attr.srcset]="imageService.buildSrcset('schnittlauch-thymian.webp', [480, 768, 1024], { quality: 80, format: 'auto' })"
          sizes="(max-width: 992px) 100vw, 50vw"
          width="768"
          height="512"
          alt="Kräuter auf einer sonnigen Fensterbank"
          decoding="async"
          loading="lazy"
          style="object-fit: cover; width:100%; height:auto;">
      </div>

      <div class="growing-text">
        <h2 id="growing-heading">Kräuter selbst anbauen</h2>
        <p>
          Frische Heilkräuter aus eigenem Anbau sind die beste Basis für wirkungsvolle Hausmittel. Wir zeigen dir, wie du
          erfolgreich auf Fensterbank, Balkon oder Beet anbaust — mit Schwerpunkt auf Standort, Erde, Pflege und schonender Ernte.
        </p>
        <ul>
          <li>Standort & Substrat: was jede Art braucht</li>
          <li>Pflege & Gießen: gesund und stressfrei anbauen</li>
          <li>Erntezeitpunkt & Erntemethode für maximale Wirkstoffe</li>
          <li>Trocknen, Lagern & Haltbarmachen</li>
        </ul>

        <!-- <a routerLink="/anbauen" class="btn-primary">Anbautipps entdecken</a> -->
      </div>

    </div>
  </div>
</section>

<!-- Blog-Preview -->
<section class="blog-preview-section" aria-labelledby="blog-heading">
  <div class="container">
    <h2 id="blog-heading" class="section-title">Aktuelle Beiträge aus unserem Blog</h2>

    <div class="blog-preview-grid">
      <ng-container *ngFor="let blog of recentBlogPosts; let i = index">
        <a [routerLink]="[blogPath, blog.slug]" class="blog-card-link">
          <article class="blog-card">
            <div class="blog-image">
              <ng-container *ngIf="imageService.getImageData(blog, blog.featuredImage) as img">
                <img
                  fill
                  [ngSrc]="imageService.getOptimizedImageUrl(img.link, { width: 768, quality: 80, format: 'auto' })"
                  disableOptimizedSrcset
                  [attr.srcset]="imageService.buildSrcset(img.link, [384, 640, 768], { quality: 80, format: 'auto' })"
                  sizes="(max-width: 600px) 100vw, (max-width: 992px) 50vw, 33vw"
                  [alt]="img.alt"
                  decoding="async"
                  style="object-fit: cover;">
              </ng-container>
            </div>

            <div class="blog-content">
              <div class="blog-meta">
                <span class="blog-date">{{ formatDate(blog.publishDate) }}</span>
                <span class="blog-category">{{ getCategoryLabel(blog.category) }}</span>
              </div>

              <h3 class="blog-title">{{ blog.title }}</h3>
              <p class="blog-excerpt">{{ getFormattedExcerpt(blog) }}</p>

              <span class="blog-link btn-secondary">Weiterlesen</span>
            </div>
          </article>
        </a>
      </ng-container>
    </div>

    <div class="more-blog-posts">
      <a [routerLink]="blogPath" class="btn-secondary">Alle Blogbeiträge ansehen</a>
    </div>
  </div>
</section>

<!-- FAQ-Sektion -->
<section class="faq-section" id="faq" aria-labelledby="faq-heading">
  <div class="container">
    <h2 id="faq-heading" class="section-title">Häufige Fragen rund um Kräuter</h2>
    <div class="faq-container">

      <details class="faq-item">
        <summary>Welche Kräuter eignen sich besonders gut für den Alltag?</summary>
        <div class="faq-answer">
          <p>
            Viele Kräuter lassen sich unkompliziert in den Alltag integrieren.
            Beliebt sind zum Beispiel Minze, Melisse, Rosmarin, Thymian und Salbei.
            Sie eignen sich für Tee, einfache Anwendungen, Pflegeideen oder als frische Begleiter im Haushalt.
          </p>
        </div>
      </details>

      <details class="faq-item">
        <summary>Welche Kräuter sind pflegeleicht und auch für Anfänger geeignet?</summary>
        <div class="faq-answer">
          <p>
            Besonders robust und einsteigerfreundlich sind Minze, Schnittlauch, Thymian, Zitronenmelisse und Rosmarin.
            Sie verzeihen kleinere Pflegefehler und wachsen sowohl im Garten als auch auf Balkon oder Fensterbank gut.
          </p>
        </div>
      </details>

      <details class="faq-item">
        <summary>Wie kann ich Kräuter sinnvoll nutzen, ohne sie zu verschwenden?</summary>
        <div class="faq-answer">
          <p>
            Überschüssige Kräuter lassen sich gut trocknen, einfrieren oder in Öl und Salz konservieren.
            Auch einfache Anwendungen wie Kräutertees, Aufgüsse oder Pflegeideen helfen,
            die Pflanzen vollständig zu nutzen.
          </p>
        </div>
      </details>

      <details class="faq-item">
        <summary>Wofür werden Kräuter traditionell angewendet?</summary>
        <div class="faq-answer">
          <p>
            Kräuter werden seit Jahrhunderten für verschiedene Zwecke genutzt –
            zur Unterstützung des Wohlbefindens, zur Entspannung, zur Pflege von Haut und Haar
            oder einfach als natürlicher Bestandteil des Alltags.
            Die genaue Anwendung hängt von der Pflanze und dem persönlichen Bedarf ab.
          </p>
        </div>
      </details>

      <details class="faq-item">
        <summary>Wann ist der beste Zeitpunkt zum Ernten von Kräutern?</summary>
        <div class="faq-answer">
          <p>
            Der ideale Erntezeitpunkt ist meist am Vormittag, nachdem der Tau getrocknet ist.
            Zu diesem Zeitpunkt ist der Gehalt an ätherischen Ölen besonders hoch.
            Geerntet wird am besten regelmäßig und nicht mehr als ein Drittel der Pflanze auf einmal.
          </p>
        </div>
      </details>

      <details class="faq-item">
        <summary>Gibt es bei der Anwendung von Kräutern etwas zu beachten?</summary>
        <div class="faq-answer">
          <p>
            Auch natürliche Pflanzen sollten bewusst verwendet werden.
            Manche Kräuter können bei empfindlichen Personen Reaktionen auslösen
            oder sind nicht für jede Situation geeignet.
            Bei Unsicherheit empfiehlt sich Zurückhaltung oder fachlicher Rat.
          </p>
        </div>
      </details>

    </div>
  </div>
</section>

